<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">

        <!-- Comercial -->
        <mat-card class="mat-elevation-z8 w-100" *ngIf="isComercial">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <!-- Linha 1 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso de 60k Sementes - Impressão (kg)</mat-label>
                                <input matInput id="txtPeso60kSementes" #txtPeso60kSementes maxlength="10"
                                    formControlName="peso_sessenta_mil_sementes_impressao_kg"
                                    (blur)="makeCalculations()" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtPeso60kSementes.value.length}} / 10</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.peso_sessenta_mil_sementes_impressao_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Numero de sementes no saco</mat-label>

                                <mat-select #txtNumSementesSaco formControlName="num_sementes_saco"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        (keyup)="createFilterNumSemente($event.target.value)">
                                    <mat-option *ngFor="let item of listNumeroSem" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.num_sementes_saco)}}</mat-error>
                            </mat-form-field>
                        </div>






                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Qtde de Sacos ou Kg
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtQtdeSacosOuKg" #txtQtdeSacosOuKg maxlength="10" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()" formControlName="qtde_sacos_ou_kg">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtDataEnsaque.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.qtde_sacos_ou_kg)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Linha de Ensaque</mat-label>
                                <mat-select #txtLinhaEnsaque formControlName="linha_ensaque" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterLinhaEnsaque($event.target.value)">
                                    <mat-option *ngFor="let item of listLinhaEnsaque" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.linha_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <!-- Linha 2 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total de Sacos</mat-label>
                                <input matInput id="txtTotalSacos" #txtTotalSacos maxlength="20"
                                    formControlName="total_sacos" currencyMask [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTotalSacos.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_sacos)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso Total do Lote (kg)</mat-label>
                                <input matInput id="txtPesoTotalLote" #txtPesoTotalLote maxlength="20"
                                    formControlName="peso_total_lote_kg" currencyMask [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPesoTotalLote.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.peso_total_lote_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data de Ensaque</mat-label>
                                <input matInput id="txtDataEnsaque" #txtDataEnsaque maxlength="10"
                                    formControlName="data_ensaque" mask="d0/M0/0000" type="text">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataEnsaque.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Qtde de Sacos ou Kg
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtQtdeSacosOuKg" #txtQtdeSacosOuKg maxlength="10" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()" formControlName="qtde_sacos_ou_kg">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtDataEnsaque.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.qtde_sacos_ou_kg)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <!-- Linha 3 -->
                    <div class="row pt-3">
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso Total do Lote (kg)</mat-label>
                                <input matInput id="txtPesoTotalLote" #txtPesoTotalLote maxlength="20"
                                    formControlName="peso_total_lote_kg" currencyMask [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPesoTotalLote.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.peso_total_lote_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data de Ensaque</mat-label>
                                <input matInput id="txtDataEnsaque" #txtDataEnsaque maxlength="10"
                                    formControlName="data_ensaque" mask="d0/M0/0000" type="text">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataEnsaque.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Linha de Ensaque</mat-label>
                                <mat-select #txtLinhaEnsaque formControlName="linha_ensaque" disableCenteringOption
                                    (selectionChange)="makeCalculations()">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterLinhaEnsaque($event.target.value)">
                                    <mat-option *ngFor="let item of listLinhaEnsaque" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.linha_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Código da Embalagem</mat-label>
                                <input matInput id="txtCodigoEmbalagem" #txtCodigoEmbalagem maxlength="10"
                                    formControlName="codigo_embalagem">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtCodigoEmbalagem.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.codigo_embalagem)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <!-- Linha 4 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Código da Embalagem</mat-label>
                                <input matInput id="txtCodigoEmbalagem" #txtCodigoEmbalagem maxlength="10"
                                    formControlName="codigo_embalagem">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtCodigoEmbalagem.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.codigo_embalagem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quantidade de Embalagens (un)</mat-label>
                                <input matInput id="txtQtdeEmbalagens" #txtQtdeEmbalagens maxlength="20"
                                    formControlName="quantidade_embalagens_un" currencyMask [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtQtdeEmbalagens.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.quantidade_embalagens_un)}}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda de Embalagens - ERRO DE IMPRESSÃO</mat-label>
                                <input matInput id="txtPerdasEmbalagensImpressao" #txtPerdasEmbalagensImpressao
                                    maxlength="10" formControlName="perdas_embalagens_erro_impressao"
                                    (blur)="makeCalculations()" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtPerdasEmbalagensImpressao.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.perdas_embalagens_erro_impressao)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 5 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda de Embalagens - ERRO DE COSTURA</mat-label>
                                <input matInput id="txtPerdasEmbalagensCostura" #txtPerdasEmbalagensCostura
                                    maxlength="10" formControlName="perdas_embalagens_erro_costura"
                                    (blur)="makeCalculations()" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtPerdasEmbalagensCostura.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.perdas_embalagens_erro_costura)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda de Embalagens - OUTRAS OCORRÊNCIAS</mat-label>
                                <input matInput id="txtPerdasEmbalagensOutrasOcorrencias"
                                    #txtPerdasEmbalagensOutrasOcorrencias maxlength="10"
                                    formControlName="perdas_embalagens_outras_ocorrencias" (blur)="makeCalculations()"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtPerdasEmbalagensOutrasOcorrencias.value.length}} / 10
                                </mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.perdas_embalagens_outras_ocorrencias)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 6 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total de Perdas de Embalagens</mat-label>
                                <input matInput id="txtTotalPerdasEmbalagens" #txtTotalPerdasEmbalagens maxlength="20"
                                    formControlName="total_perdas_embalagens" currencyMask [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTotalPerdasEmbalagens.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_perdas_embalagens)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quantidade de Embalagens (un)</mat-label>
                                <input matInput id="txtQtdeEmbalagens" #txtQtdeEmbalagens maxlength="20"
                                    formControlName="quantidade_embalagens_un" currencyMask [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtQtdeEmbalagens.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.quantidade_embalagens_un)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Status</mat-label>
                                <input matInput id="txtStatus" #txtStatus maxlength="20" formControlName="status"
                                    [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtStatus.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.status)}}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <!-- Linha 7 -->
                    <div class="row pt-3"
                        *ngIf="!formulario.controls.inicio_ensaque_data.disabled && !formulario.controls.inicio_ensaque_hora.disabled">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Ensaque Data</mat-label>
                                <input matInput id="txtIniEnsaqueData" #txtIniEnsaqueData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="inicio_ensaque_data" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtIniEnsaqueData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.inicio_ensaque_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Ensaque Hora</mat-label>
                                <input matInput id="txtIniEnsaqueHora" #txtIniEnsaqueHora maxlength="5" mask="Hh:m0"
                                    [dropSpecialCharacters]="false" formControlName="inicio_ensaque_hora"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtIniEnsaqueHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.inicio_ensaque_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 8 -->
                    <div class="row pt-3"
                        *ngIf="!formulario.controls.termino_ensaque_data.disabled && !formulario.controls.termino_ensaque_hora.disabled">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Ensaque Data</mat-label>
                                <input matInput id="txtTerEnsaqueData" #txtTerEnsaqueData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="termino_ensaque_data" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtTerEnsaqueData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.termino_ensaque_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Ensaque Hora</mat-label>
                                <input matInput id="txtTerEnsaqueHora" #txtTerEnsaqueHora maxlength="5" mask="Hh:m0"
                                    [dropSpecialCharacters]="false" formControlName="termino_ensaque_hora"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtTerEnsaqueHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.termino_ensaque_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 9 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Duração da Atividade de Ensaque (h)</mat-label>
                                <input matInput id="txtDuracaoAtividadeEnsaque" #txtDuracaoAtividadeEnsaque
                                    maxlength="20" formControlName="duracao_atividade_ensaque_h" currencyMask
                                    [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtDuracaoAtividadeEnsaque.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.duracao_atividade_ensaque_h)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Status</mat-label>
                                <input matInput id="txtStatus" #txtStatus maxlength="20" formControlName="status"
                                    [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtStatus.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.status)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade (%)</mat-label>
                                <input matInput id="txtUmidade" #txtUmidade maxlength="5" formControlName="umidade_prc"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtUmidade.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.umidade_prc)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <!-- Linha 10 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade (%)</mat-label>
                                <input matInput id="txtUmidade" #txtUmidade maxlength="5" formControlName="umidade_prc"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtUmidade.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.umidade_prc)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pela Conferência do Lote
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtResponsavelConferenciaLote" #txtResponsavelConferenciaLote
                                    maxlength="40" formControlName="responsavel_pela_conferencia_lote">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtResponsavelConferenciaLote.value.length}} / 40</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.responsavel_pela_conferencia_lote)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pelo Ensaque</mat-label>
                                <input matInput id="txtResponsavelEnsaque" #txtResponsavelEnsaque maxlength="40"
                                    formControlName="responsavel_pelo_ensaque">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtResponsavelEnsaque.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.responsavel_pelo_ensaque)}}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <!-- Linha 11 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pelo Ensaque</mat-label>
                                <input matInput id="txtResponsavelEnsaque" #txtResponsavelEnsaque maxlength="40"
                                    formControlName="responsavel_pelo_ensaque">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtResponsavelEnsaque.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.responsavel_pelo_ensaque)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pelo Apontamento
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtResponsavelApontamento" #txtResponsavelApontamento maxlength="40"
                                    formControlName="responsavel_pelo_apontamento">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtResponsavelApontamento.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.responsavel_pelo_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Silo Tratado ou PSA
                                </mat-label>
                                <input matInput id="txtSiloTratadoPSA" #txtSiloTratadoPSA maxlength="20"
                                    formControlName="silo_tratado_ou_psa">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtSiloTratadoPSA.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.silo_tratado_ou_psa)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <!-- Linha 12 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md" *ngIf="!formulario.controls.silo_tratado_ou_psa.disabled">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Silo Tratado ou PSA
                                </mat-label>
                                <input matInput id="txtSiloTratadoPSA" #txtSiloTratadoPSA maxlength="20"
                                    formControlName="silo_tratado_ou_psa">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtSiloTratadoPSA.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.silo_tratado_ou_psa)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Turno do Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtTurnoEnsaque formControlName="turno_ensaque" disableCenteringOption>
                                    <input matInput type="text" class="form-control">
                                    <mat-option *ngFor="let item of listTurnoEnsaque" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.turno_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacao"></textarea>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <!-- Linha 13 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data do Apontamento
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtDataApontamento" #txtDataApontamento maxlength="10"
                                    mask="d0/M0/0000" formControlName="data_apontamento">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataApontamento.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Hora do Apontamento
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtHoraApontamento" #txtHoraApontamento maxlength="5" mask="Hh:m0"
                                    formControlName="hora_apontamento">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtHoraApontamento.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hora_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>


                    <!-- Linha 14 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Criado por</mat-label>
                                <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40"
                                    formControlName="criado_por" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacao"></textarea>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>


        <!-- Básica -->
        <mat-card class="mat-elevation-z8 w-100" *ngIf="isBasica">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <!-- Linha 1 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso de 60k Sementes - Impressão (kg)
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtPeso60kSementes" #txtPeso60kSementes maxlength="10"
                                    formControlName="peso_sessenta_mil_sementes_impressao_kg"
                                    (blur)="makeCalculations()" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtPeso60kSementes.value.length}} / 10</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.peso_sessenta_mil_sementes_impressao_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número de Sementes no Saco
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>

                                <mat-select #txtNumSementesSsacoBasica formControlName="num_sementes_saco_basica"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control">
                                    <mat-option *ngFor="let item of listNumeroSem" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.num_sementes_saco_basica)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Qtde de Sacos ou Kg
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtQtdeSacosOuKg" #txtQtdeSacosOuKg maxlength="10" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    (blur)="makeCalculations()" formControlName="qtde_sacos_ou_kg">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtDataEnsaque.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.qtde_sacos_ou_kg)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 2 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total de Sacos</mat-label>
                                <input matInput id="txtTotalSacos" #txtTotalSacos maxlength="20"
                                    formControlName="total_sacos" currencyMask [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTotalSacos.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_sacos)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso Total do Lote (kg)</mat-label>
                                <input matInput id="txtPesoTotalLote" #txtPesoTotalLote maxlength="20"
                                    formControlName="peso_total_lote_kg" currencyMask [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPesoTotalLote.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.peso_total_lote_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 3 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data de Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtDataEnsaque" #txtDataEnsaque maxlength="10"
                                    formControlName="data_ensaque" mask="d0/M0/0000" type="text">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataEnsaque.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Linha de Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtLinhaEnsaque formControlName="linha_ensaque" disableCenteringOption>
                                    <input matInput type="text" class="form-control">
                                    <mat-option *ngFor="let item of listLinhaEnsaque" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.linha_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tamanho da Sacaria
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtTamanhoSacaria formControlName="tamanho_da_sacaria"
                                    (selectionChange)="fillPackagingCode()" disableCenteringOption>
                                    <input matInput type="text" class="form-control">
                                    <mat-option *ngFor="let item of listTamanhoSacaria" [value]="item.name"
                                        [ngClass]="item.colorClass">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tamanho_da_sacaria)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 4 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Código da Embalagem
                                </mat-label>
                                <input matInput id="txtCodigoEmbalagem" [readonly]="true" class="InputBlockColor"
                                    #txtCodigoEmbalagem maxlength="10" formControlName="codigo_embalagem">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtCodigoEmbalagem.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.codigo_embalagem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda de Embalagens - ERRO DE IMPRESSÃO
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtPerdasEmbalagensImpressao" #txtPerdasEmbalagensImpressao
                                    maxlength="10" formControlName="perdas_embalagens_erro_impressao"
                                    (blur)="makeCalculations()" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtPerdasEmbalagensImpressao.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.perdas_embalagens_erro_impressao)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda de Embalagens - ERRO DE MENSAGEM
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtPerdasEmbalagensImpressao" #txtPerdasEmbalagensImpressao
                                    maxlength="10" formControlName="perdas_embalagens_erro_mensagem"
                                    (blur)="makeCalculations()" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtPerdasEmbalagensImpressao.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.perdas_embalagens_erro_mensagem)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 5 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda de Embalagens - ERRO DE COSTURA
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtPerdasEmbalagensCostura" #txtPerdasEmbalagensCostura
                                    maxlength="10" formControlName="perdas_embalagens_erro_costura"
                                    (blur)="makeCalculations()" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtPerdasEmbalagensCostura.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.perdas_embalagens_erro_costura)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Perda de Embalagens - OUTRAS OCORRÊNCIAS
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtPerdasEmbalagensOutrasOcorrencias"
                                    #txtPerdasEmbalagensOutrasOcorrencias maxlength="10"
                                    formControlName="perdas_embalagens_outras_ocorrencias" (blur)="makeCalculations()"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtPerdasEmbalagensOutrasOcorrencias.value.length}} / 10
                                </mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.perdas_embalagens_outras_ocorrencias)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quantidade de Embalagem Canguru
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtQntdEmbalagemCanguru" #txtQntdEmbalagemCanguru maxlength="10"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                                    formControlName="qntd_embalagem_canguru" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtQntdEmbalagemCanguru.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.qntd_embalagem_canguru)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 6 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total de Perdas de Embalagens</mat-label>
                                <input matInput id="txtTotalPerdasEmbalagens" #txtTotalPerdasEmbalagens maxlength="20"
                                    formControlName="total_perdas_embalagens" currencyMask [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTotalPerdasEmbalagens.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_perdas_embalagens)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quantidade de Embalagens (un)</mat-label>
                                <input matInput id="txtQtdeEmbalagens" #txtQtdeEmbalagens maxlength="20"
                                    formControlName="quantidade_embalagens_un" currencyMask [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtQtdeEmbalagens.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.quantidade_embalagens_un)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 7 -->
                    <!-- <div class="row pt-3">
                    <div class="col-lg col-md" *ngIf="!formulario.controls.inicio_ensaque_data.disabled">
                        <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                            floatLabel="{{formFieldFloatLabel}}">
                            <mat-label class="InputLabelColor">Início Ensaque Data
                              <span class="InputRequired">{{required}}</span>
                            </mat-label>
                            <input matInput id="txtIniEnsaqueData" #txtIniEnsaqueData maxlength="10"
                                [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                formControlName="inicio_ensaque_data" (blur)="makeCalculations()">
                            <i matSuffix class="{{iconEnableField}}"></i>
                            <mat-hint align="start" class="InputLabelDetailsColor">
                                {{hintDate}}</mat-hint>
                            <mat-hint align="end">{{txtIniEnsaqueData.value.length}} / 10</mat-hint>
                            <mat-error>{{hasErrorFormControl(formulario.controls.inicio_ensaque_data)}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg col-md"  *ngIf="!formulario.controls.termino_ensaque_data.disabled">
                      <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                          floatLabel="{{formFieldFloatLabel}}">
                          <mat-label class="InputLabelColor">Término Ensaque Data
                            <span class="InputRequired">{{required}}</span>
                          </mat-label>
                          <input matInput id="txtTerEnsaqueData" #txtTerEnsaqueData maxlength="10"
                              [dropSpecialCharacters]="false" mask="d0/M0/0000"
                              formControlName="termino_ensaque_data" (blur)="makeCalculations()">
                          <i matSuffix class="{{iconEnableField}}"></i>
                          <mat-hint align="start" class="InputLabelDetailsColor">
                              {{hintDate}}</mat-hint>
                          <mat-hint align="end">{{txtTerEnsaqueData.value.length}} / 10</mat-hint>
                          <mat-error>{{hasErrorFormControl(formulario.controls.termino_ensaque_data)}}
                          </mat-error>
                      </mat-form-field>
                  </div>
                </div> -->


                    <!-- Linha 8 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pela Conferência do Lote
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtResponsavelConferenciaLote" #txtResponsavelConferenciaLote
                                    maxlength="40" formControlName="responsavel_pela_conferencia_lote">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtResponsavelConferenciaLote.value.length}} / 40</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.responsavel_pela_conferencia_lote)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pelo Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtResponsavelEnsaque" #txtResponsavelEnsaque maxlength="40"
                                    formControlName="responsavel_pelo_ensaque">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtResponsavelEnsaque.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.responsavel_pelo_ensaque)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 9 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pelo Apontamento</mat-label>
                                <input matInput id="txtResponsavelApontamento" #txtResponsavelApontamento maxlength="40"
                                    formControlName="responsavel_pelo_apontamento">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtResponsavelApontamento.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.responsavel_pelo_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Turno do Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtTurnoEnsaque formControlName="turno_ensaque" disableCenteringOption>
                                    <input matInput type="text" class="form-control">
                                    <mat-option *ngFor="let item of listTurnoEnsaque" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.turno_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 10 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Descarte Tratado (kg)
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtDescarteTratado" #txtDescarteTratado maxlength="10"
                                    formControlName="descarte_tratado_kg" currencyMask>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtDescarteTratado.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.descarte_tratado_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data do Apontamento</mat-label>
                                <input matInput id="txtDataApontamento" #txtDataApontamento maxlength="10"
                                    mask="d0/M0/0000" formControlName="data_apontamento">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataApontamento.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 11 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Criado por</mat-label>
                                <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="80"
                                    formControlName="criado_por" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtCriadoPor.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacao"></textarea>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>


        <!-- Pré Basica-->
        <mat-card class="mat-elevation-z8 w-100" *ngIf="isPreBasica">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <!-- Linha 8 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pela Conferência do Lote
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtResponsavelConferenciaLote" #txtResponsavelConferenciaLote
                                    maxlength="40" formControlName="responsavel_pela_conferencia_lote">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtResponsavelConferenciaLote.value.length}} / 40</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.responsavel_pela_conferencia_lote)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pelo Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtResponsavelEnsaque" #txtResponsavelEnsaque maxlength="40"
                                    formControlName="responsavel_pelo_ensaque">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtResponsavelEnsaque.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.responsavel_pelo_ensaque)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 9 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pelo Apontamento</mat-label>
                                <input matInput id="txtResponsavelApontamento" #txtResponsavelApontamento maxlength="40"
                                    formControlName="responsavel_pelo_apontamento">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtResponsavelApontamento.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.responsavel_pelo_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Turno do Ensaque
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtTurnoEnsaque formControlName="turno_ensaque" disableCenteringOption>
                                    <input matInput type="text" class="form-control">
                                    <mat-option *ngFor="let item of listTurnoEnsaque" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.turno_ensaque)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data Conferência Física
                                </mat-label>
                                <input matInput id="txtDataConferenciaFisica" #txtDataInicio maxlength="10"
                                    mask="d0/M0/0000" formControlName="data_conferencia_fisica"
                                    [dropSpecialCharacters]="false" (blur)="calcDates($event)">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-error
                                    *ngIf="formulario.controls.data_conferencia_fisica.hasError('dateHighThanActual')">A
                                    data não pode ser menor que a Data de Ensaque</mat-error>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_conferencia_fisica)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data do Apontamento</mat-label>
                                <input matInput id="txtDataApontamento" #txtDataApontamento maxlength="10"
                                    mask="d0/M0/0000" formControlName="data_hora_apontamento"
                                    (blur)="calcDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataApontamento.value.length}} / 10</mat-hint>
                                <mat-error
                                    *ngIf="formulario.controls.data_conferencia_fisica.hasError('dateHighThanActual')">A
                                    data não pode ser menor que a Data de Ensaque</mat-error>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_hora_apontamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 10 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Status de Processo
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <mat-select #txtTurnoEnsaque formControlName="status_processo" disableCenteringOption>
                                    <input matInput type="text" class="form-control">
                                    <mat-option *ngFor="let item of listStatusProcesso" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.status_processo)}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Criado por</mat-label>
                                <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="80"
                                    formControlName="criado_por" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtCriadoPor.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 11 -->
                    <div class="row pt-3">

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacao"></textarea>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>